import { Directive, OnInit } from '@angular/core';
import {
  BaseSelectGridFilterDirective,
  FilterInput
} from '@app/pcs/shared/containers/search-results-grid/filters/base-select-grid-filter.directive';
import { Store } from '@ngrx/store';
import { hasNoValue, hasValue, isArray, isBoolean, isNotEqual, isTrue } from '@util';
import { FilteringOptions, GridFilter } from 'ngrx-data-grid';
import * as R from 'ramda';

const containsValue = (value, isArray) => R.ifElse(hasValue,
  isArray ? R.any(R.equals(value)) : R.equals(value),
  R.always(false)) as any;
const notContainsValue = (value, isArray) => R.ifElse(hasValue,
  isArray ? R.all(isNotEqual(value)) : isNotEqual(value),
  R.always(true)) as any;

const filterByOption = (option: FilteringOptions, value, isArray) => R.cond([
  [
    R.equals(FilteringOptions.Equals),
    R.always(containsValue(value, isArray))
  ],
  [
    R.equals(FilteringOptions.NotEqual),
    R.always(notContainsValue(value, isArray))
  ]
])(option);


@Directive()
export abstract class SingleSelectGridFilterDirective<T> extends BaseSelectGridFilterDirective<T> implements OnInit, GridFilter<FilterInput<T>> {

  showOnlyRowsWithNoOptions = false;
  selectedOption = null;

  readonly options = [
    FilteringOptions.Equals,
    FilteringOptions.NotEqual
  ];

  constructor(protected store?: Store<any>) {
    super(store);
  }

  ngOnInit(): void {
    if (isBoolean(this.value)) {
      this.showOnlyRowsWithNoOptions = this.value;
      this.selectedOption = null;
    } else {
      this.selectedOption = this.value;
    }
    super.ngOnInit();
  }

  filter({option, value, rawValue}) {
    return isTrue(value)
      ? hasNoValue(rawValue)
      : filterByOption(option, value, isArray(rawValue))(rawValue) as boolean;
  }

  onSelectionChanged(value: T) {
    this.value = value;
    this.valueChanged.emit(this.value);
  }

  clear(): void {
    this.value = null;
  }

  onShowOnlyRowsWithNoOptionsChanged(value) {
    this.showOnlyRowsWithNoOptions = value;
    if (this.showOnlyRowsWithNoOptions) {
      this.valueChanged.emit(this.showOnlyRowsWithNoOptions);
    } else {
      this.valueChanged.emit(this.selectedOption);
    }
  }

}
